import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../services/filtering/filter-form-render-service/';
import { messages } from './messages';

export const CustomerEmail = {
  id: 'customerEmail',
  displayName: <FormattedMessage {...messages.customerEmail} />,
  type: OptionFormTypes.TYPE_IS_OPTIONS,
  filterValue: 'returnEmailStatus',

  render: (criteriaInformations) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_IS_OPTIONS, criteriaInformations);
  },
};
